import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getEstoqueContato from "../queries/getEstoqueContato";


export function useGetEstoqueContato(ContatoId: number) {
  const resultQuery = useQuery(
    [`${URLS.CONTATO_ESTOQUE_API}`, {
      params: {ContatoId}
    }], 
    () => getEstoqueContato(ContatoId));

  return resultQuery;
}
